import React from 'react';
import type { DefaultAutomationTemplateMetadata } from '@reach/shared-types/automation-template';
import styles from './CreateTemplateDialog.module.css';

interface TemplateCardProps {
  template: DefaultAutomationTemplateMetadata;
  onSelect: (templateName: string) => void;
}

export const TemplateCard: React.FC<TemplateCardProps> = ({ template, onSelect }) => {
  return (
    <button type="button" className={styles.templateButton} onClick={() => onSelect(template.name)}>
      <header>
        <h3>{template.displayName}</h3>
        <p>{template.description}</p>
      </header>
      <span className={styles.useTemplateText}>Use Template →</span>
    </button>
  );
};
